let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("9zLwF"), load("arhgZ"), load("aiXoK")]).then(() => parcelRequire('j3YP6'));